// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"8c6e5c3a","703":"8cbded2b","925":"0987fa4c"}[chunkId] + ".chunk.js";
};